module.exports = __webpack_public_path__ + "media/new/approve_step_3a-ea49df33.png";